"use client"

import Button from "../shared/Button"

export default function Modal({ isOpen, onClose, icon, heading, description, buttonText, onButtonClick }) {
  if (!isOpen) return null

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick()
    } else {
      onClose()
    }
  }

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/70"
        onClick={onClose} // <-- click anywhere on backdrop closes modal
      />

      {/* Modal Container */}
      <div className="relative z-10 flex flex-col items-center gap-7 w-full max-w-[490px] sm:w-[490px] py-[40px] px-4 sm:px-0 rounded-[22px] bg-white shadow-2xl">
        
        {/* Icon */}
        {icon && <div className="w-[100px] h-[100px] flex justify-center items-center">{icon}</div>}

        {/* Heading */}
        <h2 className="text-[25px] font-bold text-dark-blue text-center font-plusJakartaSans leading-normal">
          {heading}
        </h2>

        {/* Description */}
        <p className="text-[20px] font-normal text-gray text-center px-4 sm:px-8 leading-[30px]">
          {description}
        </p>

        {/* Button */}
        <Button
          onClick={handleButtonClick}
          className="flex justify-center items-center gap-2 w-full max-w-[410px] h-[55px] py-[12px] rounded-[10px] text-white font-medium transition-all duration-200 hover:opacity-90 focus:outline-none focus:ring-1 focus:ring-offset-2 focus:ring-orange-500"
          style={{ background: "linear-gradient(90deg, #F36E49 0%, #B67FE2 100%)" }}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  )
}
